import { Typography, Box } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import { handleOpenPdf } from "Components/Shared/PartyIdentificationImages/utils";
import { UnstyledButton } from "Components/Shared/Buttons/UnstyledButton";

type Props = {
  base64Data: string;
};

export const PDFDetail = ({ base64Data }: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" gap={1} alignItems="baseline">
      <Typography>{t(Resources.AML.PdfUploaded)}</Typography>
      <UnstyledButton
        onClick={() => handleOpenPdf(base64Data)}
        sx={{
          cursor: "pointer",
          color: "primary.main",
          textDecoration: "underline",
        }}
      >
        {t(Resources.AML.OpenPdf)}
      </UnstyledButton>
    </Box>
  );
};
